import { render } from "./videoModal.vue?vue&type=template&id=0ad46872&scoped=true"
import script from "./videoModal.vue?vue&type=script&lang=js"
export * from "./videoModal.vue?vue&type=script&lang=js"

import "./videoModal.vue?vue&type=style&index=0&id=0ad46872&lang=scss&scoped=true"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad46872"]])

export default __exports__